import { render, staticRenderFns } from "./ZCtongxingchangtoushouyi.vue?vue&type=template&id=4153041f&scoped=true"
import script from "./ZCtongxingchangtoushouyi.vue?vue&type=script&lang=js"
export * from "./ZCtongxingchangtoushouyi.vue?vue&type=script&lang=js"
import style0 from "./ZCtongxingchangtoushouyi.vue?vue&type=style&index=0&id=4153041f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4153041f",
  null
  
)

export default component.exports